export function FindAndRemove<T>(array: Array<T>, find: (item: T) => boolean) {
    const cloneArray = Array.from(array);
    const index = cloneArray.findIndex(find);
    array.splice(index, 1);
}

export function getArrayReducer<T>(equals: (itemA: T, itemB: T) => boolean) {
    return function arrayReducer(
        state: Array<T>,
        options:
            | { action: "remove" | "add"; newItem: T | T[] }
            | undefined
            | T[]
    ) {
        const clone = options ? state.map((i) => i) : [];
        if (options) {
            if (Array.isArray(options)) {
                return options;
            } else {
                switch (options.action) {
                    case "add":
                        if (Array.isArray(options.newItem))
                            clone.push(...options.newItem);
                        else clone.push(options.newItem);
                        break;
                    case "remove":
                        if (Array.isArray(options.newItem))
                            options.newItem.forEach((item) =>
                                FindAndRemove(clone, (item) =>
                                    equals(item, item)
                                )
                            );
                        else
                            FindAndRemove(clone, (item) =>
                                equals(item, options.newItem as T)
                            );
                        break;
                    default:
                        break;
                }
            }
        }
        return clone;
    };
}
